import type { CSSProperties } from "react";

/** Hues in the caret palette (`--caret-0` to `--caret-5`); the server hands each tab one as its presence `colour`. */
export const CARET_COLOURS = 6;

export type CaretColour = 0 | 1 | 2 | 3 | 4 | 5;

/** Normalizes a presence `colour` from the wire onto a palette slot: out-of-range integers wrap, anything else is 0. */
export function toCaretColour(value: unknown): CaretColour {
  const index = typeof value === "number" && Number.isInteger(value) ? value : 0;
  return (((index % CARET_COLOURS) + CARET_COLOURS) % CARET_COLOURS) as CaretColour;
}

/** Points the Tailwind `caret` colour (`bg-caret`, `bg-caret/20`, `border-caret`, `animate-caret-insert`) at one slot. */
export function caretStyle(colour: CaretColour): CSSProperties {
  return { "--caret": `var(--caret-${colour})` } as CSSProperties;
}
